import LineItem from './LineItem'
import AlbumOrderSummary from './AlbumOrderSummary'
import LabOrderPaperService from './LabOrderPapersServices'
import LineItemFilters from './LineItemFilters'
import { useEffect, useState } from 'react'
import { useLabOrderDetailsStore } from '../../../../stores'
import { LAB_ORDER_STATUS } from '../../../../lib/const'

const OrderSummary = () => {
  const {filteredLineItems,filteredMultiOpeningLineItems,filteredAlbumOrderDetails,selectedItems,setSelectedItems,globalSelect,setGlobalSelect,isAdmin,updateLineItemStatus,labOrderId,orderStatus, updateOrderStatus,statusUpdating,trackingLoading} = useLabOrderDetailsStore();

  const [loading, setLoading] = useState(false)
  
  useEffect(() => {
    setGlobalSelect(false)
    setSelectedItems([])
  }, [filteredLineItems, filteredMultiOpeningLineItems, setGlobalSelect, setSelectedItems])

  const handleGlobalSelect = () => {
    if (globalSelect) {
      setSelectedItems([]);
    } else {
      const mySelection = [...filteredLineItems, ...filteredMultiOpeningLineItems].map((item) => item?.attributes?.guid)
      setSelectedItems(mySelection)
    }
    setGlobalSelect(!globalSelect)
  }

  const updateStatus = async (e) => {
    if (!updateLineItemStatus) return;
    try {
      setLoading(true);
      await updateLineItemStatus(e, selectedItems, labOrderId);
    } catch (error) {
      console.error('Error updating status:', error);
    } finally {
      setLoading(false);
    }
  };
  
  const handleUpdateOrderStatus = async (e) => {
    try {
      const value = e.target.value;
      await updateOrderStatus(labOrderId, value);
    } catch (error) {
      console.error("Error updating lab order:", error);
    }
  };

  return (
    <>
      <div className="_3rd-block-container-order lab-order-summary">
        <div className="heading-container">
          <div className="grid-order-icons mobile">
            {isAdmin && (
              <div
                className="div-block-98"
                style={{ flexDirection: 'row', paddingBottom: 0, alignItems: 'center' }}
              >
                <label className="field-label-2">Order Status</label>
                <div
                  style={{ display: 'flex', opacity: statusUpdating && !trackingLoading ? 0.6 : 1 }}
                  className="div-block-99"
                >
                  <select
                    className="select-field-3-copy _2 w-select"
                    value={orderStatus ?? 'open'}
                    onChange={handleUpdateOrderStatus}
                    disabled={statusUpdating && !trackingLoading}
                  >
                    {Object.keys(LAB_ORDER_STATUS).map((key) => (
                      <option key={key} value={key}>
                        {LAB_ORDER_STATUS[key].label}
                      </option>
                    ))}
                  </select>
                  {statusUpdating && !trackingLoading && (
                    <div
                      className="spinner"
                      style={{
                        width: '18px',
                        height: '18px',
                        border: '2px solid #ccc',
                        borderTop: '2px solid #000',
                        borderRadius: '50%',
                        animation: 'spin 0.6s linear infinite',
                      }}
                    ></div>
                  )}
                </div>
              </div>
            )}
            {isAdmin && <LabOrderPaperService />}
          </div>
          {isAdmin && <LineItemFilters />}
        </div>
        {(selectedItems.length > 0)
          &&
          <div id="" className="form-block-18 w-form">
            <form id="email-form-6" name="email-form-6" data-name="Email Form 6" className="">
              <div className="div-block-98-copy"><label className="field-label-2-copy">Update Line Item Status</label>
                <div className="div-block-358" style={{ opacity: loading ? 0.6 : 1 }}>
                  <select data-name="Field 3" name="field-3" className="select-field-3-copy w-select"
                    onChange={(e) => { updateStatus(e) }} disabled={loading}>

                    <option value="reset">Change Status</option>
                    <option value="open">Open</option>
                    <option value="paid">Paid</option>
                    <option value="printing">Printing</option>
                    <option value="matting">Matting</option>
                    <option value="mounting">Mounting</option>
                    <option value="framing">Framing</option>
                    <option value="canvas_production">Canvas Prod</option>
                    <option value="album_production">Album Prod</option>
                    <option value="ready_to_ship">Ready To Ship</option>
                    <option value="shipped">Shipped</option>
                    <option value="reprint">Reprint</option>
                    <option value="on_hold">On Hold</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                  {loading && (
                    <div
                      className="spinner"
                      style={{
                        width: '18px',
                        height: '18px',
                        border: '2px solid #ccc',
                        borderTop: '2px solid #000',
                        borderRadius: '50%',
                        animation: 'spin 0.6s linear infinite',
                      }}
                    ></div>
                  )}
                </div>
              </div>
            </form>
          </div>
        }

        <div className="container-rightside-order-summary">
          <div
            className={`w-layout-grid grid-element-order-summary head lab-order-line-items-header ${isAdmin ? "unbundled-list" : "client"}`}
            style={{
              gridTemplateColumns: isAdmin
                ? '35px 60px 100px 140px 110px 160px 230px 35px 65px 100px 50px'
                : '80px 180px 110px 140px 160px 55px 65px',
            }}
          >
            {/* Checkbox column */}
            {isAdmin && <div
              id="w-node-f3b21e65-a50e-06d4-6be3-7f53c5576c35-6be80a0f"
              className="heady order-summary-checkbox-cell"
              style={{ textAlign: isAdmin ? 'left' : 'center' }}
            >
              <div className="form-block-7 w-form">
                <form id="email-form-4" name="email-form-4" data-name="Email Form 4">
                  <label className="w-checkbox">
                    <div
                      className={`w-checkbox-input w-checkbox-input--inputType-custom
                       ${(globalSelect && selectedItems.length == filteredLineItems.length + filteredMultiOpeningLineItems.length) ? "w--redirected-checked" : selectedItems.length > 0 ? "w--redirected-indeterminate" : ""} checkbox-7 _2`}
                      style={{
                        width: "16px",
                        height: "16px",
                        border: "1px solid #ccc",
                        marginRight: "6px",
                      }}
                      onClick={handleGlobalSelect}
                    >
                    </div>
                  </label>
                  <span className="checkbox-label-2 w-form-label">Checkbox 8</span>
                </form>
              </div>
            </div>}
            {/* Empty block */}
            {isAdmin && <div
              id="w-node-f3b21e65-a50e-06d4-6be3-7f53c5576c42-6be80a0f"
              className="heady"
              style={{ textAlign: isAdmin ? 'left' : 'center' }}
            >
              <div className="div-block-353"></div>
            </div>}
            {/* Columns */}
            <div className="heady" style={{ textAlign: isAdmin ? 'left' : 'center' }}>
              <div>Image</div>
            </div>

            <div className="heady print-details" style={{ textAlign: isAdmin ? 'left' : 'center' }}>
              <div>Print Details</div>
            </div>

            <div className="heady" style={{ textAlign: isAdmin ? 'left' : 'center' }}>
              <div>Finish Type</div>
            </div>

            <div className="heady" style={{ textAlign: isAdmin ? 'left' : 'center' }}>
              <div>Details</div>
            </div>

            <div className="heady" style={{ textAlign: isAdmin ? 'left' : 'center' }}>
              <div>Notes</div>
            </div>

            <div className="heady" style={{ textAlign: isAdmin ? 'left' : 'center' }}>
              <div>Qty</div>
            </div>

            <div className="heady" style={{ textAlign: isAdmin ? 'left' : 'center' }}>
              <div>Total</div>
            </div>

            {isAdmin && <div className="heady" style={{ textAlign: isAdmin ? 'left' : 'center' }}>
              <div>Status</div>
            </div>}

            {/* SVG Icon */}

            {isAdmin && <div className="heady" style={{ textAlign: isAdmin ? 'left' : 'center' }}>
            </div>}
          </div>

          <div className={!isAdmin ? "w-layout-grid grid-order-summary-container single" : "w-layout-grid grid-order-summary-container"}>
            {filteredLineItems && filteredLineItems?.map((lineItem) => (
              <LineItem key={`lineitem-${lineItem.id}`}
                lineItem={lineItem.attributes}
              />
            ))}
            {filteredMultiOpeningLineItems && filteredMultiOpeningLineItems?.map((lineItem) => (
              <LineItem key={`multi-opening-lineitem-${lineItem.id}`}
                lineItem={{ ...lineItem.attributes, isMultiOpening: true }}
              />
            ))}
            <AlbumOrderSummary albumOrderDetailsProp={filteredAlbumOrderDetails} />
          </div>
        </div>
      </div >
    </>
  )
}

export default OrderSummary
